import React from "react";
import assign from "lodash/assign";
import get from "lodash/get";
import set from "lodash/set";
import {
  TextField,
  RaisedButton,
  RadioButtonGroup,
  RadioButton,
  Checkbox
} from "material-ui";
import { SketchPicker } from "react-color";

import InfoNotice from "./partials/info-notice.jsx";
import WorkingIndicator from "./partials/working-indicator.jsx";

import BackButton from "./partials/back-button.jsx";

import connectToStores from "alt-utils/lib/connectToStores";
import TagActions from "../actions/TagActions";
import TagStore from "../stores/TagStore";
import EventBucketStore from "../stores/EventBucketStore";

import TagPreview from "./partials/tag-preview.jsx";

class Tag extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tag: null,
      dirty: false,
      isFetchingTag: false,
      values: {}
    };

    this.onChangeValue = this.onChangeValue.bind(this);
    this.save = this.save.bind(this);
    this.delete = this.delete.bind(this);
  }

  static getStores() {
    return [TagStore, EventBucketStore];
  }

  static getPropsFromStores() {
    return {
      getTagById: TagStore.getTagById,
      presetColors: TagStore.getState().presetColors,
      isSaving: TagStore.getState().isSaving
    };
  }

  static get contextTypes() {
    return {
      router: React.PropTypes.object
    };
  }

  getStyles() {
    return {
      actions: {
        marginTop: 40
      },
      h3: {
        marginTop: 10,
        marginBottom: 10
      }
    };
  }

  onChangeValue(id, value) {
    this.state.dirty = true;
    set(this.state.values, id, value);
    this.setState(this.state);
  }

  save() {
    var values = assign({}, this.state.values);
    TagActions.edit(this.props.params.tagId, values);
  }

  delete() {
    let bucket = this.state.tag.event_bucket;
    if (window.confirm("Are you sure?")) {
      TagActions.delete(this.props.params.tagId);
      this.context.router.push(`/event_buckets/${bucket}/tags`);
    }
  }

  componentDidMount() {
    TagActions.fetchPresetColors(); // used in colorpicker
    this.componentWillReceiveProps(this.props);
  }

  componentWillReceiveProps(newProps) {
    var tag = newProps.getTagById(newProps.params.tagId);

    this.setState({
      tag,
      dirty: false,
      values: tag
        ? {
            name: tag.name || "",
            color: tag.color || "",
            virtual_festival_display_mode:
              tag.virtual_festival_display_mode || "",
            visible: typeof tag.visible === "undefined" ? true : tag.visible
          }
        : {}
    });

    if (!this.state.isFetchingTag && !tag) {
      TagActions.fetchOne(newProps.params.tagId);
      this.setState({ isFetchingTag: true });
    } else if (this.state.isFetchingTag && tag) {
      this.setState({ isFetchingTag: false });
    }
  }

  render() {
    const styles = this.getStyles(),
      showVirtualFestivalConfig = (
        EventBucketStore.getEventBucketById(this.props.params.eventBucketId) ||
        {}
      ).enable_virtual_festival;

    if (!this.state.tag || this.props.isSaving) {
      return <WorkingIndicator fullPage={true} />;
    }

    let saveButton = (
      <RaisedButton
        label={this.state.dirty ? "Save changes" : "No changes to save"}
        primary={true}
        disabled={!this.state.dirty}
        onTouchTap={this.save}
      />
    );

    return (
      <div>
        <div>
          <BackButton
            label="tags"
            style={{ marginRight: 7 }}
            onTouchTap={() =>
              this.props.location.state && this.props.location.state.fromListing
                ? this.context.router.goBack()
                : this.context.router.push(
                    `/event_buckets/${this.props.params.eventBucketId}/tags`
                  )
            }
          />
          {saveButton}
        </div>
        <InfoNotice style={{ marginTop: 20 }}>
          Check out our{" "}
          <a
            href="http://help.eventive.org/events-and-tickets/create-tags"
            target="_blank"
          >
            guide to creating tags
          </a>
          .
        </InfoNotice>
        <div>
          <div>
            <TextField
              value={get(this.state, "values.name", "")}
              floatingLabelText="Name"
              floatingLabelFixed={true}
              autoFocus
              onChange={e => this.onChangeValue("name", e.target.value)}
            />
          </div>
          <div style={{ margin: "1.5em 0" }}>
            <Checkbox
              label="Hide tag from public views"
              onCheck={e => this.onChangeValue("visible", !e.target.checked)}
              checked={!get(this.state, "values.visible", true)}
            />
          </div>
          {showVirtualFestivalConfig ? (
            <div style={{ margin: "1.5em 0" }}>
              <h3 style={styles.h3}>Virtual Catalog display mode</h3>
              <RadioButtonGroup
                valueSelected={this.state.values.virtual_festival_display_mode}
                onChange={(e, v) =>
                  this.onChangeValue("virtual_festival_display_mode", v)
                }
              >
                <RadioButton value={"default"} label={"Default"} />
                <RadioButton value={"poster"} label={"Poster"} />
                <RadioButton
                  value={"big_poster"}
                  label={"Big poster with title"}
                />
                <RadioButton
                  value={"giant_slider"}
                  label={
                    "Full-width large slider with still, title and description"
                  }
                />
                <RadioButton value={"cover"} label={"Full-width cover image"} />
                <RadioButton
                  value={"default_grid"}
                  label={"Default, as grid (no slider)"}
                />
              </RadioButtonGroup>
            </div>
          ) : null}
          <div>
            <h3 style={styles.h3}>Color</h3>
            <TagPreview
              label={this.state.values.short_name || this.state.values.name}
              color={this.state.values.color}
            />
            <div style={{ marginTop: 10 }}>
              <SketchPicker
                color={this.state.values.color}
                presetColors={this.props.presetColors}
                disableAlpha={true}
                onChange={color => this.onChangeValue("color", color.hex)}
              />
            </div>
          </div>
        </div>
        <div style={styles.actions}>
          {saveButton}
          <RaisedButton
            label="Delete tag"
            onTouchTap={this.delete}
            style={{ marginLeft: 7 }}
          />
        </div>
      </div>
    );
  }
}

export default connectToStores(Tag);



// WEBPACK FOOTER //
// ./src/app/components/tag-editor.jsx